<app-breadcrumb [master]="'Sprzedaż'" [parentName]="'Importuj'" [name]="'Importuj'"></app-breadcrumb>
<div class="sold-policy-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="soldPolicyImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <app-file-drag-and-drop
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="text/csv"
          ></app-file-drag-and-drop>

          <mat-error *ngIf="soldPolicyImportForm.get('fileContent').hasError('backendError')">
            {{soldPolicyImportForm.get('fileContent').getError('backendError')}}
          </mat-error>

          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Firma"
              dictType="company"
              [control]="companyControl"
              [required]="false"
            ></app-dict>
          </div>

          <div fxLayout="row">
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="true"
              [control]="insuranceCompanyControl"
              [companyId]="importCompanyId"
            ></app-dict-insurance-companies>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!soldPolicyImportFormValid"
            mat-stroked-button color="primary"><mat-icon>publish</mat-icon> <span> Importuj</span></button>
  </div>
</div>
